module.exports = __webpack_public_path__ + "static/media/hometown-3-shot-1.55babf37.webp";